import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Plus, Cross } from '@teo/components/icons';
import { IconButton } from '@teo/components';

const CustomNodeEmpty = (node) => {
  return (
    <>
      {node?.data?.handlePosition === 'all' && (
        <>
          <Handle
            type="target"
            position={Position.Top}
            id="b"
            className="!pointer-events-none !opacity-0"
          />
          <Handle type="target" position={Position.Left} id="a-1" />
          <Handle type="source" position={Position.Left} id="a" />
        </>
      )}
      {node?.data?.handlePosition === 'bottom' && (
        <Handle
          type="target"
          position={Position.Top}
          id="b"
          className="!pointer-events-none !opacity-0"
        />
      )}
      {node?.data?.handlePosition === 'right' && (
        <Handle
          type="target"
          position={Position.Left}
          id="a-1"
          className="!pointer-events-none !opacity-0"
        />
      )}
      <div className="relative flex h-full min-h-24 w-full">
        <IconButton
          Icon={Cross}
          variant="secondary"
          className="settings_btn absolute right-2 top-2 hidden"
          onClick={() =>
            node?.data?.handleRemoveNode({
              id: node.id,
              type: node.type,
            })
          }
        />
        <Plus className="m-auto w-6 text-grey-06" />
      </div>
      {node?.data?.handlePosition === 'left' && (
        <Handle
          type="target"
          position={Position.Right}
          id="c-1"
          className="!pointer-events-none !opacity-0"
        />
      )}
      {node?.data?.handlePosition === 'all' && (
        <>
          <Handle type="target" position={Position.Right} id="c-1" />
          <Handle type="source" position={Position.Right} id="c" />
          <Handle type="source" position={Position.Bottom} id="d" />
        </>
      )}
    </>
  );
};

export default memo(CustomNodeEmpty);
